export default {
      id: "123,4_cm-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#123,4_cm",
      toString: function () {
        return this.url;
      }
    }